import React from 'react';
import BudgetAllocationWorkspace from './BudgetAllocationWorkspace';

/** 예산배정계획수립 */
export default function BudgetAllocPlan() {
  return <BudgetAllocationWorkspace screenMode="plan" />;
}
